<div class="container-1" *ngIf="!isLoggedIn">
  <mat-card class="mat-elevation-z5">
    <div class="right">
      <div>
        <img [src]="camLogo" />
        <h6>Eat well, feel well, live well</h6>
      </div>
      <div>
        <h1>Welcome back</h1>
      </div>
      <div class="form-field">
        <mat-form-field appearance="fill">
          <mat-label>Email ID</mat-label>
          <input type="email" matInput [(ngModel)]="emailId" />
          <mat-icon matSuffix>email</mat-icon>
        </mat-form-field>
      </div>
      <div class="form-field">
        <mat-form-field appearance="fill">
          <mat-label>Password</mat-label>
          <input
            matInput
            [type]="hide ? 'password' : 'text'"
            [(ngModel)]="password"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div>
        <button mat-raised-button class="primary-btn" (click)="login()">
          Login
        </button>
      </div>
    </div>
  </mat-card>
</div>

<div class="container-2" *ngIf="isLoggedIn">
  <mat-card class="email-verify">
    <h1>Phewww...</h1>
    <img [src]="sadIcon" />
    <h2>
      "It seems that your email address has not been verified yet, so kindly
      check your email inbox for the verification link."
    </h2>
    <button mat-raised-button class="primary-btn" (click)="isLoggedIn = false">
      Email verified? Login again
    </button>
  </mat-card>
</div>
